<template>
  <router-view></router-view>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions({
      presetStation: 'station/preset',
      initLocale: 'settings/initLocale'
    }),
    init () {
      this.presetStation()
      this.initLocale()
    }
  },
  mounted () {
    this.init()
  }
}
</script>
